/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_Recovery_AdequateInputs */

const en_ui_stat_recovery_adequate = /** @type {(inputs: Ui_Stat_Recovery_AdequateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adequate recovery`)
};

const de_ui_stat_recovery_adequate = /** @type {(inputs: Ui_Stat_Recovery_AdequateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gute Erholung`)
};

/**
* | output |
* | --- |
* | "Adequate recovery" |
*
* @param {Ui_Stat_Recovery_AdequateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_recovery_adequate = /** @type {((inputs?: Ui_Stat_Recovery_AdequateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_Recovery_AdequateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_recovery_adequate(inputs)
	return de_ui_stat_recovery_adequate(inputs)
});